
import NewPassword from '~/components/NewPassword/index.vue'
import {
  buildPageHead,
  buildAnalyticsMeta,
  buildHeadScripts,
} from '@/helpers/pageSeo'

export default {
  components: { NewPassword },
  head() {
    const pageTitle = `${this.$custom$t('new-password')} | ${this.$store.state.settings.title}`
    const { title, meta, link } = buildPageHead(this, {
      title: pageTitle,
      description: this.$custom$t('seo.pages.newPassword.description'),
    })
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title,
      meta: [...meta, ...buildAnalyticsMeta(this)],
      link,
      script: buildHeadScripts(this),
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
}
